import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CURRENCY_SYMBOL_FLOAT } from '../models/language.model';

/**
 * This Pipe transforms price to correct number format with currency symbol attached to it
 * example: 1234 -> $1 234
 */
@Pipe({ name: 'formatCurrency' })
export class FormatCurrencyPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: number): string {
    if (value === undefined || value === null) {
      return '';
    }

    const thousandSeparator = this.translate.instant('global.thousandSeparator');
    const decimalSeparator = this.translate.instant('global.decimalSeparator');
    const decimalLimit = Number(this.translate.instant('global.decimalNumbersMoney'));
    const symbol = this.translate.instant('global.currencySymbol');
    const symbolFloat = this.translate.instant('global.currencySymbolFloat');

    let price = Number(value)
      .toFixed(decimalLimit)
      .replace('.', decimalSeparator);

    const parts = price.split(decimalSeparator);
    parts[0] = parts[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    price = parts.join(decimalSeparator);
    const currencySymbolOptions = {
      [CURRENCY_SYMBOL_FLOAT.LEFT]: `${symbol}${price}`,
      [CURRENCY_SYMBOL_FLOAT.RIGHT]: `${price}${symbol}`,
      default: `${symbol}${price}`,
    };

    return currencySymbolOptions[symbolFloat] || currencySymbolOptions['default'];
  }
}
